import { render, staticRenderFns } from "./SurveyDashboard.vue?vue&type=template&id=fefa1cac&scoped=true&"
import script from "./SurveyDashboard.vue?vue&type=script&lang=js&"
export * from "./SurveyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDashboard.vue?vue&type=style&index=0&id=fefa1cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefa1cac",
  null
  
)

export default component.exports